"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var Sentry = _interopRequireWildcard(require("@sentry/react"));

var _tracing = require("@sentry/tracing");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useSentry = function useSentry(initProps) {
  var history = initProps.history,
      dsn = initProps.dsn,
      page = initProps.page,
      version = initProps.version;
  (0, _react.useEffect)(function () {
    (function () {
      Sentry.init({
        dsn: dsn,
        integrations: [new _tracing.Integrations.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
        })],
        tracesSampleRate: 1.0,
        release: page + '@' + version,
        ignoreErrors: ['ResizeObserver loop limit exceeded', 'AbortError: Failed to get ServiceWorkerRegistration objects: The Service Worker system has shutdown.', 'ResizeObserver loop completed with undelivered notifications.', 'cancelled']
      });
    })();

    return; // eslint-disable-next-line
  }, []);
};

var _default = useSentry;
exports.default = _default;

//# sourceMappingURL=useSentry.js.map